import API_GATEWAY from "@/services/config/main-axios";

const versioningService = {
  getLastVersion() {
    return API_GATEWAY.get("backoffice/app-version/getLastVersion");
  },

  addVersion(model) {
    return API_GATEWAY.post("backoffice/app-version/addVersion", model);
  }
};

export default versioningService;
